import type { LibraryItem } from '@/types';

/**
 * Whether a feed slide should offer the Edit affordance.
 *
 * Two conditions, both required: the CMS opted this preset in (`hasEditOption`),
 * AND it actually has an optional input to reveal. Without an optional input the
 * sheet would only show inputs the main CTA already collects, so Edit would be a
 * second button to the same place.
 *
 * Reads the grid item rather than the loaded preset so the button's presence is
 * decided at paint, with no dependence on the active slide's preset fetch.
 */
const canEditPresetInputs = (item: LibraryItem): boolean =>
  Boolean(item.hasEditOption) &&
  ((item.uploadItems ?? []).some((input) => input.optional) ||
    (item.textItems ?? []).some((input) => input.optional));

export default canEditPresetInputs;
